import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Checkbox,
  Button,
  Icon,
  Dropdown
} from 'semantic-ui-react'

const CardRehabTreatmentUX = (props: any) => {
    return(
      <div
        id="CardRehabTreatmentUX-div-0"
        style={{margin:"2px 6px"}}>
        <div
          id="CardRehabTreatmentUX-div-11"
          style={{display:"flex",justifyContent:"space-between",margin:"5px 0px", alignItems:"center"}}>
          
          <div
            id="CardRehabTreatmentUX-div-2"
            style={{display:"flex", gap:"20px",margin:"8px 0px", alignItems: "baseline"}}>
            
            <div
              id="CardRehabTreatmentUX-div-5"
              style={{color: "rgba(0, 114, 188, 1)",fontWeight:"bolder",fontSize:"larger",alignItems:"center"}}>
              {props.languageUX === "en" ? "Treatment plan list" : "รายการแผนการรักษา"}
            </div>
            <Checkbox
              checked={props.isIncludePerformed}
              disabled={props.showOnlyCancelledPlan}
              id="CardRehabTreatmentUX-Checkbox-8"
              label={props.languageUX === "en" ? "Include Performed" : "รวมการดำเนินการ"}
              onChange={props.onChangeIncludePerformed}
              style={{display: props.hideFilter?"none":""}}>
            </Checkbox>
            <Checkbox
              id="CardRehabTreatmentUX-Checkbox-9"
              label={props.languageUX === "en" ? "Include Finished" : "รวมเสร็จสิ้น"}
              style={{display: "none"}}>
            </Checkbox>
            <Checkbox
              checked={props.showOnlyCancelledPlan}
              className="red-checkbox"
              id="CardRehabTreatmentUX-Checkbox-41"
              label={props.languageUX === "en" ? "Show Only Cancelled Plan" : "แสดงเฉพาะแผนการรักษาที่ยกเลิก"}
              onChange={props.onChangeShowOnlyCancelledplan}>
            </Checkbox>
          </div>
          <div
            id="CardRehabTreatmentUX-div-12"
            style={{display:props.hideMode?"none":"flex",gap:"6px", height:"40%", alignItems: "center"}}>
            
            <label
              id="CardRehabTreatmentUX-label-16"
              style={{fontWeight:"bolder"}}>
              {props.languageUX === "en" ? "Select the action:" : "เลือกการดำเนินการ:"}
            </label>
            <Button
              color="yellow"
              icon={true}
              id="CardRehabTreatmentUX-Button-13"
              name="PRINT"
              onClick={props.onSelectMode}
              size="mini"
              style={{display:props.selectedMode?"none":""}}>
              {}
              <Icon
                id="CardRehabTreatmentUX-Icon-17"
                name="print">
              </Icon>
              <label
                id="CardRehabTreatmentUX-label-18"
                style={{marginLeft: "6px"}}>
                {props.languageUX === "en" ? "Print booking" : "พิมพ์การจอง"}
              </label>
            </Button>
            <Button
              color="blue"
              icon={true}
              id="CardRehabTreatmentUX-Button-14"
              name="APPOINTMENT"
              onClick={props.onSelectMode}
              size="mini"
              style={{display:props.selectedMode?"none":""}}>
              {}
              <Icon
                id="CardRehabTreatmentUX-Icon-19"
                name="calendar alternate outline">
              </Icon>
              <label
                id="CardRehabTreatmentUX-label-20"
                style={{marginLeft: "6px"}}>
                {props.languageUX === "en" ? "Appointment" : "การนัดหมาย"}
              </label>
            </Button>
            <Button
              color="green"
              icon={true}
              id="CardRehabTreatmentUX-Button-15"
              name="PERFORM"
              onClick={props.onSelectMode}
              size="mini"
              style={{display:props.selectedMode?"none":""}}>
              {}
              <Icon
                id="CardRehabTreatmentUX-Icon-21"
                name="check square outline">
              </Icon>
              <label
                id="CardRehabTreatmentUX-label-22"
                style={{marginLeft: "6px"}}>
                {props.languageUX === "en" ? "Perform Treatment" : "ดำเนินการรักษา"}
              </label>
            </Button>
            <Button
              color="red"
              icon={true}
              id="CardRehabTreatmentUX-Button-23"
              onClick={props.onCancelMode}
              size="mini"
              style={{display:props.selectedMode?"":"none"}}>
              <Icon
                id="CardRehabTreatmentUX-Icon-24"
                name="step backward">
              </Icon>
              <label
                id="CardRehabTreatmentUX-label-25"
                style={{marginLeft: "6px"}}>
                {props.languageUX === "en" ? "BACK" : "กลับ"}
              </label>
            </Button>
            <div
              id="CardRehabTreatmentUX-div-29"
              style={{display:props.selectedMode==="PERFORM"?"":"none"}}>
              {props.buttonPerform}
            </div>
            <Button
              color="blue"
              disabled={props.disabledAppointment}
              icon={true}
              id="CardRehabTreatmentUX-Button-30"
              onClick={props.onMakeAppointment}
              size="mini"
              style={{display:props.selectedMode==="APPOINTMENT"?"":"none"}}>
              <Icon
                id="CardRehabTreatmentUX-Icon-31"
                name="calendar alternate outline">
              </Icon>
              <label
                id="CardRehabTreatmentUX-label-32"
                style={{marginLeft: "6px"}}>
                {props.languageUX === "en" ? "Make Appointment" : "นัดหมาย"}
              </label>
            </Button>
            <div
              className="ui form size mini"
              id="CardRehabTreatmentUX-div-37"
              style={{display:props.selectedMode==="PRINT"?"flex":"none", alignItems: "center"}}>
              
              <label
                id="CardRehabTreatmentUX-label-38"
                style={{marginRight: "0.5rem"}}>
                {props.languageUX === "en" ? "language" : "ภาษา"}
              </label>
              <Dropdown
                fluid={true}
                id="CardRehabTreatmentUX-Dropdown-39"
                onChange={props.onChangeLanguage}
                options={props.languageOptions}
                selection={true}
                style={{ width: "7rem",marginRight: "0.5rem"}}
                value={props.language}>
              </Dropdown>
              <div
                id="CardRehabTreatmentUX-div-40">
                {props.buttonPrint}
              </div>
            </div>
          </div>
        </div>
        <div
          className="ui divider"
          id="CardRehabTreatmentUX-div-34"
          style={{display: props.closeIcon? "":"none", margin: "0rem 0 0.5rem"}}>
          
          <div
            id="CardRehabTreatmentUX-div-35"
            style={{position: "absolute", right: "0.75rem", top: "1rem"}}>
            
            <Icon
              color="red"
              id="CardRehabTreatmentUX-Icon-36"
              link={true}
              name="close"
              onClick={props.onClose}>
            </Icon>
          </div>
        </div>
        <div
          id="CardRehabTreatmentUX-div-7"
          style={{marginBottom: "1rem"}}>
          {props.treatmentPlan}
        </div>
        <div
          id="CardRehabTreatmentUX-div-10"
          style={{display: props.onSelectRehab?"flex":"none", justifyContent: "flex-end", marginTop: "1rem"}}>
          {}
          <Button
            color="blue"
            id="CardRehabTreatmentUX-Button-33"
            onClick={props.onSelectRehab}
            size="small">
            {props.languageUX === "en" ? "Select" : "เลือก"}
          </Button>
        </div>
      </div>
    )
}


export default CardRehabTreatmentUX

export const screenPropsDefault = {}

/* Date Time : Tue Sep 09 2025 12:05:42 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"2px 6px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", gap:\"20px\",margin:\"8px 0px\", alignItems: \"baseline\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการแผนการรักษา",
          "valueEN": "Treatment plan list"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(0, 114, 188, 1)\",fontWeight:\"bolder\",fontSize:\"larger\",alignItems:\"center\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.treatmentPlan"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{marginBottom: \"1rem\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Checkbox",
      "parent": 2,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.isIncludePerformed"
        },
        "disabled": {
          "type": "code",
          "value": "props.showOnlyCancelledPlan"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-Checkbox-8"
        },
        "label": {
          "type": "value",
          "value": "รวมการดำเนินการ",
          "valueEN": "Include Performed"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeIncludePerformed"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideFilter?\"none\":\"\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "Checkbox",
      "parent": 2,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-Checkbox-9"
        },
        "label": {
          "type": "value",
          "value": "รวมเสร็จสิ้น",
          "valueEN": "Include Finished"
        },
        "style": {
          "type": "code",
          "value": "{display: \"none\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{display: props.onSelectRehab?\"flex\":\"none\", justifyContent: \"flex-end\", marginTop: \"1rem\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",justifyContent:\"space-between\",margin:\"5px 0px\", alignItems:\"center\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{display:props.hideMode?\"none\":\"flex\",gap:\"6px\", height:\"40%\", alignItems: \"center\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Button",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-Button-13"
        },
        "name": {
          "type": "value",
          "value": "PRINT"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSelectMode"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{display:props.selectedMode?\"none\":\"\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Button",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-Button-14"
        },
        "name": {
          "type": "value",
          "value": "APPOINTMENT"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSelectMode"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{display:props.selectedMode?\"none\":\"\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 15,
      "name": "Button",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-Button-15"
        },
        "name": {
          "type": "value",
          "value": "PERFORM"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSelectMode"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{display:props.selectedMode?\"none\":\"\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกการดำเนินการ:",
          "valueEN": "Select the action:"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-label-16"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight:\"bolder\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Icon",
      "parent": 13,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-Icon-17"
        },
        "name": {
          "type": "value",
          "value": "print"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "label",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์การจอง",
          "valueEN": "Print booking"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-label-18"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"6px\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "Icon",
      "parent": 14,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-Icon-19"
        },
        "name": {
          "type": "value",
          "value": "calendar alternate outline"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "label",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "การนัดหมาย",
          "valueEN": "Appointment"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-label-20"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"6px\"}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Icon",
      "parent": 15,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-Icon-21"
        },
        "name": {
          "type": "value",
          "value": "check square outline"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "label",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "ดำเนินการรักษา",
          "valueEN": "Perform Treatment"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-label-22"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"6px\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Button",
      "parent": 12,
      "props": {
        "color": {
          "type": "value",
          "value": "red"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-Button-23"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCancelMode"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{display:props.selectedMode?\"\":\"none\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Icon",
      "parent": 23,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-Icon-24"
        },
        "name": {
          "type": "value",
          "value": "step backward"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "label",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": "กลับ",
          "valueEN": "BACK"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-label-25"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"6px\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPerform"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{display:props.selectedMode===\"PERFORM\"?\"\":\"none\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Button",
      "parent": 12,
      "props": {
        "color": {
          "type": "value",
          "value": "blue"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledAppointment"
        },
        "icon": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-Button-30"
        },
        "onClick": {
          "type": "code",
          "value": "props.onMakeAppointment"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{display:props.selectedMode===\"APPOINTMENT\"?\"\":\"none\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "Icon",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-Icon-31"
        },
        "name": {
          "type": "value",
          "value": "calendar alternate outline"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "label",
      "parent": 30,
      "props": {
        "children": {
          "type": "value",
          "value": "นัดหมาย",
          "valueEN": "Make Appointment"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-label-32"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"6px\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 33,
      "name": "Button",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือก",
          "valueEN": "Select"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-Button-33"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSelectRehab"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-div-34"
        },
        "style": {
          "type": "code",
          "value": "{display: props.closeIcon? \"\":\"none\", margin: \"0rem 0 0.5rem\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 34,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-div-35"
        },
        "style": {
          "type": "code",
          "value": "{position: \"absolute\", right: \"0.75rem\", top: \"1rem\"}"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "Icon",
      "parent": 35,
      "props": {
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-Icon-36"
        },
        "link": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "close"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form size mini"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-div-37"
        },
        "style": {
          "type": "code",
          "value": "{display:props.selectedMode===\"PRINT\"?\"flex\":\"none\", alignItems: \"center\"}"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": null,
      "id": 38,
      "name": "label",
      "parent": 37,
      "props": {
        "children": {
          "type": "value",
          "value": "ภาษา",
          "valueEN": "language"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-label-38"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "Dropdown",
      "parent": 37,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-Dropdown-39"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeLanguage"
        },
        "options": {
          "type": "code",
          "value": "props.languageOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"7rem\",marginRight: \"0.5rem\"}"
        },
        "value": {
          "type": "code",
          "value": "props.language"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 40,
      "name": "div",
      "parent": 37,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrint"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-div-40"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "Checkbox",
      "parent": 2,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.showOnlyCancelledPlan"
        },
        "className": {
          "type": "value",
          "value": "red-checkbox"
        },
        "id": {
          "type": "value",
          "value": "CardRehabTreatmentUX-Checkbox-41"
        },
        "label": {
          "type": "value",
          "value": "แสดงเฉพาะแผนการรักษาที่ยกเลิก",
          "valueEN": "Show Only Cancelled Plan"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeShowOnlyCancelledplan"
        },
        "style": {
          "type": "value",
          "value": ""
        },
        "toggle": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 41,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardRehabTreatmentUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
